import type { ReactNode } from "react";

/**
 * The frame a dial setting sits in.
 *
 * Status roles and Feeds arrived as modals, each behind its own button in the dial's top bar. Moving them
 * onto the Settings tab meant they needed a heading where the modal's title bar used to be — otherwise a
 * section that opens with a table of role chips gives no clue what it is. Same shape as the settings that
 * were written as sections from the start (Display, Device), so the tab reads as one thing rather than as
 * a pile of relocated dialogs.
 */
export function SettingsCard({
  title,
  subtitle,
  actions,
  children,
}: {
  title: string;
  subtitle?: string;
  /** Rendered on the title row — a Save/Discard pair, a mint button. Optional. */
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="kd-card" style={{ padding: "var(--pad-card)", display: "flex", flexDirection: "column", gap: 12, minWidth: 0 }}>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text)" }}>{title}</div>
          {subtitle && (
            <div style={{ marginTop: 3, fontSize: 13, lineHeight: 1.55, color: "var(--text-muted)" }}>{subtitle}</div>
          )}
        </div>
        {actions}
      </div>
      <div style={{ minWidth: 0 }}>{children}</div>
    </div>
  );
}
